import { axiosSwagger } from "@/axios";


export const state = {
    publicRecent: {
        loading: false,
        data: [],
        total: 0,
    },
}


export const getters = {
}


export const mutations = {
    // CATEGORY
    loading: (state, loading) => {
        state.publicRecent.loading = loading;
    },
    setData: (state, data) => {
        state.publicRecent.data = modifyData( data );
    },
    setTotal: (state, total) => {
        state.publicRecent.total = total;
    }
}


export const actions = {
    // READ PUBLIC RECENT FILES LIMIT TO 10
    async readPublicRecentFiles({ commit }) {
        commit("loading", true);

        return await axiosSwagger
        .get(`/api/FilePosting/Public`)
        .then((response) => {
            commit("setData", response.data);
            commit("setTotal", response.data.length);
            commit("loading", false);

            return response;
        })
        .catch(() => {
            commit("loading", false);
        });
    }
}



// modify data to limit
const modifyData = (arrayData) => {
    if(arrayData?.length ?? false){
  
      return arrayData.slice(0,9);
    }
  
    return [];
};